import { useMemo } from 'react';
import { useOptimisticallyUpdatedPinnedViewIds } from './useOptimisticallyUpdatedPinnedViewIds';
import { useCurrentViewId } from '../../../views/hooks/useCurrentViewId';
export const usePinnedViewIdsWithCurrentView = () => {
  const currentViewId = useCurrentViewId();
  const optimisticallyUpdatedPinnedViewIds = useOptimisticallyUpdatedPinnedViewIds();
  const pinnedViewIdsWithCurrentView = useMemo(() => optimisticallyUpdatedPinnedViewIds.includes(currentViewId) ? optimisticallyUpdatedPinnedViewIds : [...optimisticallyUpdatedPinnedViewIds, currentViewId], [currentViewId, optimisticallyUpdatedPinnedViewIds]);
  return pinnedViewIdsWithCurrentView;
};